// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"c0714a55","596":"d812645d"}[chunkId] + ".chunk.js";
};